import {Placement} from 'common';
import {Tooltip as BaseTooltip} from 'Tooltip';

import type {ReactElement} from 'react';

import type {ChipProps} from '../types';

type ChipTooltipProps = {children: ReactElement} & ChipProps;

export const Tooltip: React.FC<ChipTooltipProps> = props => {
  const {children, label, maxLength} = props;

  let content = props.tooltip;

  if (!content && label && maxLength && label.length > maxLength) {
    content = label;
  }

  if (!content) {
    return children;
  }

  return (
    <BaseTooltip placement={Placement.Bottom} content={content}>
      {children}
    </BaseTooltip>
  );
};
